import transliterate from '@sindresorhus/transliterate';

const getCredentials = async (host: string, token: string) => {
  const response = await fetch(`${host}/chat_widgets/direct_uploader_creds?token=${token}`);
  const data = await response.json();
  return data;
};

const uploadFile = async (host: string, token: string, file: File) => {
  const { uri, fields } = await getCredentials(host, token);
  const formFields = fields;
  const fileName = transliterate(file.name.replaceAll(' ', '_'));
  formFields.key = formFields.key.replace(/\${filename}/g, fileName);
  const formData = new FormData();
  formData.append('Content-Type', 'multipart/form-data');
  Object.entries(fields).forEach((entry: [string, string]) => formData.append(entry[0], entry[1]));
  formData.append('file', file);
  fetch(uri, {
    method: 'post',
    body: formData,
  });

  return { fileName, key: formFields.key };
};

const DirectS3Uploader = {
  uploadFile,
};

export default DirectS3Uploader;
